// Copyright (c) 2017 Deere & Company

import Home from './components/home';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.home,
    claimSettings: state.user.details.settings.claims.status.allowedStatuses,
    cloudConfig: state.appConfig.cloud,
    favorites: state.app.favorites,
    isSapUp: state.app.sapStatus.isSapUp,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts,
    userId: state.user.details.id
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(Home);



// WEBPACK FOOTER //
// ./src/home-page/state-connector.js